import toast from 'react-hot-toast';
import { client } from '@/services/api/axios.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export const useDeleteUserSessionsMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: unknown) => void;
  } = { onSuccess: () => {} }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const deletePromise = client.delete(`/auth/sessions`);

      const { data } = await toast.promise(deletePromise, {
        loading: 'Deleting all sessions...',
        success: 'All sessions deleted successfully',
        error: (error) => {
          if (axios.isAxiosError(error)) {
            return error?.response?.data?.message || 'Failed to delete sessions';
          }
          return error instanceof Error ? error.message : 'Failed to delete sessions';
        },
      });

      return data.body;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['auth', 'sessions'],
      });
    },
  });
};
